import React from 'react'
import { IconButton, Tooltip, Box } from '@mui/material'
import LockIcon from '@mui/icons-material/Lock'

/**
 * Lock Icon Button Component
 * Small lock icon in corner that triggers idle popup
 */
export function LockIconButton({ onClick, sx = {} }) {
  return (
    <Tooltip title="Lock Screen" arrow>
      <IconButton
        onClick={onClick}
        sx={{
          position: 'fixed',
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          width: { xs: 40, sm: 48 },
          height: { xs: 40, sm: 48 },
          backgroundColor: 'rgba(103, 121, 227, 0.1)',
          border: '1px solid rgba(103, 121, 227, 0.3)',
          color: '#6779e3',
          zIndex: 1000,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          '&:hover': {
            backgroundColor: 'rgba(103, 121, 227, 0.2)',
            transform: 'scale(1.05)',
          },
          transition: 'all 0.2s ease',
          ...sx,
        }}
      >
        <LockIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
      </IconButton>
    </Tooltip>
  )
}

